export const VIEWPORT_W = 1400;
export const VIEWPORT_H = 2400;

/** Full world width — two panels side by side. */
export const ASSET_W = 2800;
export const ASSET_H = 2400;

/** Physical geode frame size in crack spritesheets. */
export const GEODE_FRAME = 575;
/** Logical on-screen geode size. */
export const GEODE_DISPLAY = 1250;
/** Tight fallback radius — visible geode is ~55% of the frame, not the full PNG. */
export const GEODE_HIT_RADIUS_RATIO = 0.28;

export const DEFAULT_GEODE = 'Dust Geode';
/** 0 = explore (left), 1 = play (right, geode). */
export const DEFAULT_PANEL = 1;
